import {
  UPDATE_CPM_DETAILS_CHANGE,
  RESET_CPM_DETAILS_CHANGE,
  FETCH_CPM_DETAILS_START,
  FETCH_CPM_DETAILS_SUCCESS,
  FETCH_CPM_DETAILS_ERROR,
  FETCH_CPM_DETAILS_SELECTION_START,
  FETCH_CPM_DETAILS_SELECTION_SUCCESS,
  FETCH_CPM_DETAILS_SELECTION_ERROR,
  POST_CPM_DETAILS_START,
  POST_CPM_DETAILS_SUCCESS,
  POST_CPM_DETAILS_ERROR,
  UPDATE_NINE_HUNDRED_LEVEL_PART_NUMBER,
  UPDATE_PROJECT_PRIORITY_ID,
  UPDATE_PRODUCT_SAMPLED_ID,
  UPDATE_READY_FOR_REVIEW_ID,
  UPDATE_PUBLISH_TO_WEB_ID,
  UPDATE_CPM_NOTES,
  UPDATE_GENERAL_AVAILABILITY,
  UPDATE_PROD_RELEASE
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const updateCpmDetailsChange = (prevDetails, { details }) => Object.assign({}, details)

const setLoadingTrue = () => true
const setLoadingFalse = () => false

const loadingReducer = createReducer(setLoadingFalse(), {
  [FETCH_CPM_DETAILS_START]: setLoadingTrue,
  [FETCH_CPM_DETAILS_SUCCESS]: setLoadingFalse,
  [FETCH_CPM_DETAILS_ERROR]: setLoadingFalse,
  [FETCH_CPM_DETAILS_SELECTION_START]: setLoadingTrue,
  [FETCH_CPM_DETAILS_SELECTION_SUCCESS]: setLoadingFalse,
  [FETCH_CPM_DETAILS_SELECTION_ERROR]: setLoadingFalse,
  [POST_CPM_DETAILS_START]: setLoadingTrue,
  [POST_CPM_DETAILS_SUCCESS]: setLoadingFalse,
  [POST_CPM_DETAILS_ERROR]: setLoadingFalse,
})

const updateNineHundredLevelPartNumber = (prevDetails, { partNumber }) => partNumber != null
  ? {...prevDetails, nineHundredLevelPartNumber: partNumber}
  : prevDetails

const updateProjectPriorityId = (prevDetails, { projectPriorityId }) => projectPriorityId != null
  ? {...prevDetails, projectPriorityId: projectPriorityId}
  : prevDetails

const updateProductSampledId = (prevDetails, { productSampledId }) => productSampledId != null
  ? {...prevDetails, productSampledId: productSampledId}
  : prevDetails

const updateReadyForReviewId = (prevDetails, { readyForReviewId }) => readyForReviewId != null
  ? {...prevDetails, readyForReviewId: readyForReviewId}
  : prevDetails

const updatePublishToWebId = (prevDetails, { publishToWebId }) => publishToWebId != null
  ? {...prevDetails, publishToWebId: publishToWebId}
  : prevDetails

const updateCpmNotes = (prevDetails, { cpmNotes }) => cpmNotes != null
  ? {...prevDetails, cpmNotes: cpmNotes}
  : prevDetails

const updateProdRelease = (prevDetails, { prodRelease}) => prodRelease!= null
  ? {...prevDetails, prodRelease: prodRelease}
  : prevDetails

const updateGeneralAvailability = (prevDetails, { generalAvailability }) => generalAvailability!= null
  ? {...prevDetails, generalAvailability: generalAvailability}
  : prevDetails

const cpmDetailsChangeReducer = createReducer({}, {
  [RESET_CPM_DETAILS_CHANGE]: () => {},
  [UPDATE_CPM_DETAILS_CHANGE]: updateCpmDetailsChange,
  [UPDATE_NINE_HUNDRED_LEVEL_PART_NUMBER]: updateNineHundredLevelPartNumber,
  [UPDATE_PROJECT_PRIORITY_ID]: updateProjectPriorityId,
  [UPDATE_PRODUCT_SAMPLED_ID]: updateProductSampledId,
  [UPDATE_READY_FOR_REVIEW_ID]: updateReadyForReviewId,
  [UPDATE_PUBLISH_TO_WEB_ID]: updatePublishToWebId,
  [UPDATE_CPM_NOTES]: updateCpmNotes,
  [UPDATE_PROD_RELEASE]: updateProdRelease,
  [UPDATE_GENERAL_AVAILABILITY]: updateGeneralAvailability,
})

export default combineReducers({
  cpmDetailsChange: cpmDetailsChangeReducer,
  loading: loadingReducer
})
